import spinner from '../images/portal.gif'

export default function Loading(){
    return <img className="spinner" src={spinner} alt="Rick and Morty portal"/>;
}